module.exports = "/_next/static/images/8b2a49c8d5bb54598f9ef1c7c08381a8-two-people-looking-md@2x.jpg.webp";